import React, { useState } from 'react';
import SecureImage from '../../../../components/BucketImage/Image';
import { downArrow } from '../../../../common/svg';

const BaseToggle = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  
  // Booking data from the image
  const bookingData = {
    booking: {
      label: "Booking",
      value: "Zentax",
      id: "#78933ET",
      type: "Export"
    },
    trip: {
      label: "Trip",
      value: "Zentax",
      id: "#78933ET",
      type: "Direct Drop"
    },
    ewayBill: {
      label: "Eway Bill",
      value: "6574765875675756",
      id: "15 Number",
      number: "6574765875675756"
    },
    driver: {
      label: "Driver",
      value: "Praveen Elumalai",
      contact: "+91 8667392199"
    },
    transporter: {
      label: "Transporter",
      value: "Kittivaasal Technologies Pvt Ltd",
      contact: "+91 8667392199",
      location: "Chennai"
    },
    container: {
      linerName: "CMA CGM",
      bookingNo: "6574765875675756",
      size: "20\" ft",
      type: "Refrigerated",
      emptyWeight: "03 Tons",
      condition: "Good"
    }
  };

  return (
    <div className="bg-white shadow-md border rounded-lg overflow-hidden">
      {/* Main details section - always visible */}
      <div className="p-3 grid grid-cols-1 md:grid-cols-5 gap-2 text-sm">
        <div className="flex flex-col">
          <span className="text-gray-500 text-[14px]">Booking</span>
          <span className="font-medium text-[14px] text-blue-600">{bookingData.booking.value}</span>
          <div className="flex items-center gap-1">
            <span className="text-[14px] text-gray-600">{bookingData.booking.id}</span>
            <span className="text-[14px] text-gray-500">{bookingData.booking.type}</span>
          </div>
        </div>
        
        <div className="flex flex-col">
          <span className="text-gray-500 text-[14px]">Trip</span>
          <span className="font-medium text-[14px] text-blue-600">{bookingData.trip.value}</span>
          <div className="flex items-center gap-1">
            <span className="text-[14px] text-gray-600">{bookingData.trip.id}</span>
            <span className="text-[14px] text-gray-500">{bookingData.trip.type}</span>
          </div>
        </div>
        
        <div className="flex flex-col">
          <span className="text-gray-500 text-[14px]">Eway Bill</span>
          <span className="font-medium text-[14px]">{bookingData.ewayBill.value}</span>
          <div className="flex items-center gap-1">
            <span className="text-[14px] text-gray-600">{bookingData.ewayBill.id}</span>
          </div>
        </div>
        
        <div className="flex flex-col">
          <span className="text-gray-500 text-[14px]">Driver</span>
          <span className="font-medium text-[14px]">{bookingData.driver.value}</span>
          <div className="flex items-center gap-1">
            <span className="text-[14px] text-gray-600">{bookingData.driver.contact}</span>
          </div>
        </div>
        
        <div className="flex flex-col">
          <span className="text-gray-500 text-[14px]">Transporter</span>
          <span className="font-medium text-[14px]">{bookingData.transporter.value}</span>
          <div className="flex flex-col">
            <span className="text-[14px] text-gray-600">{bookingData.transporter.contact}</span>
            <span className="text-[14px] text-gray-600">{bookingData.transporter.location}</span>
          </div>
        </div>
      </div>
      
      {/* Container details - expandable section */}
      <div
        className={`transition-all duration-300 ease-in-out overflow-hidden  
         `}
      >
        <div className="p-2">
          <div className="grid grid-cols-1 md:grid-cols-6 gap-4 text-sm">
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Liner Name</span>
              <span className="font-medium text-[14px] text-blue-600">{bookingData.container.linerName}</span>
            </div>
            
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Container Booking No</span>
              <span className="font-medium text-[14px] ">{bookingData.container.bookingNo}</span>
            </div>
            
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Size</span>
              <span className="font-medium text-[14px]">{bookingData.container.size}</span>
            </div>
            
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Type</span>
              <span className="font-medium text-[14px]">{bookingData.container.type}</span>
            </div>
            
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Empty Weight</span>
              <span className="font-medium text-[14px]">{bookingData.container.emptyWeight}</span>
            </div>
            
            <div className="flex flex-col">
              <span className="text-gray-500 text-[14px]">Condition</span>
              <span className="font-medium text-[14px]">{bookingData.container.condition}</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Toggle button */}
      {/* <div className="flex justify-center items-center relative h-6">
        <button
          onClick={toggleExpand}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? "Collapse details" : "Expand details"}
          className="flex justify-center items-center bg-white w-8 h-8 absolute -bottom-4 rounded-full shadow-md border border-gray-100"
        >
          <SecureImage
            fileKey={downArrow}
            alt={isExpanded ? "Collapse" : "Expand"}
            className={`transition-transform duration-300 ${
              isExpanded ? "rotate-180" : ""
            }`}
            width="16px"
          />
        </button>
      </div> */}
    </div>
  );
};

export default BaseToggle;